<template>
    <div v-if="webzine" class="wz_cont">
        <div class="col_wrap">
            <div
                class="home_cover"
                v-on:click="goHome()"
                style="display: flex;"
            >
                <img :src="bookSrc" alt="" />
                <img :src="magazineSrc" alt="magazine" />
                <img :src="vertcalSrc" alt="치읏치읏" />
                <img :src="playSrc" alt="" />
                <div>
                    <i></i>
                    <i></i>
                </div>
            </div>
            <router-view name="toc" />
            <div class="col_list">
                <web-zine-view-header />
                <router-view name="content" />
                <div class="wz_footer">
                    <web-zine-view-footer-subscribe />
                    <web-zine-view-copy-right />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import "element-ui/lib/theme-chalk/display.css";
import { mapActions, mapGetters, mapMutations } from "vuex";

import WebZineViewHeader from "@/components/WebZineViewHeader";
import WebZineViewFooterSubscribe from "@/components/WebZineViewFooterSubscribe";
import WebZineViewCopyRight from "@/components/WebZineViewCopyRight";
const CONFIG = require("../config/webzine.config.json")[process.env.NODE_ENV];
const VUE_APP_API_SERVER_HOST = CONFIG.VUE_APP_API_SERVER_HOST;
export default {
    name: "WebZineViewMain",
    components: {
        WebZineViewCopyRight,
        WebZineViewFooterSubscribe,
        WebZineViewHeader,
    },
    mounted() {
        const mode = this.$route.params.mode;
        const webzineId = this.$route.params.webzine_id;

        if (mode !== "preview" && mode !== "publish") {
            this.$router.push("/");
        } else {
            this.setSelectedWebZineId(Number(webzineId));
            this.setMode(this.$route.params.mode);
            if (!this.webZineList || this.webZineList.length === 0) {
                this.getWebZineList().then(() => {
                    return this.getWebZineHandle();
                });
            } else {
                this.getWebZineHandle();
            }
        }
    },
    watch: {
        selectedWebZineId() {
            this.getWebZineHandle();
        },
    },
    data() {
        return {
            isArticles: false,
        };
    },
    computed: {
        ...mapGetters("webzineView", [
            "isPreview",
            "selectedWebZineId",
            "selectedArticleId",
            "mode",
            "categoryList",
            "articleList",
            "webZineList",
            "webzine",
        ]),
        bookSrc: {
            get() {
                return `${VUE_APP_API_SERVER_HOST}/images/common/ico-book.svg`;
            },
        },
        magazineSrc: {
            get() {
                return `${VUE_APP_API_SERVER_HOST}/images/common/img-text-magazine.svg`;
            },
        },
        vertcalSrc: {
            get() {
                return `${VUE_APP_API_SERVER_HOST}/images/common/img-logo-webzine-vertcal.svg`;
            },
        },
        playSrc: {
            get() {
                return `${VUE_APP_API_SERVER_HOST}/images/common/ico-play.svg`;
            },
        },
    },
    methods: {
        ...mapActions("webzineView", ["getWebZine", "getWebZineList"]),
        ...mapMutations("webzineView", [
            "setMode",
            "setSelectedWebZineId",
            "setSelectedArticleId",
        ]),
        getWebZineHandle() {
            const loading = this.$cmmLoading();

            this.getWebZine(this.selectedWebZineId)
                .then(() => {
                    if (!this.isPreview && this.webZineList.length === 0) {
                        return this.getWebZineList();
                    } else {
                        return Promise.resolve();
                    }
                })
                .then(() => {
                    const articleId = this.$route.params.article_id;
                    if (articleId) {
                        this.setSelectedArticleId(Number(articleId));
                    }
                    return Promise.resolve();
                })
                .catch(() =>
                    this.$errorMessage(
                        "웹진 정보 조회 중에 오류가 발생했습니다."
                    )
                )
                .finally(() => loading.close());
        },
        goHome() {
            window.location.href = window.location.origin;
        },
    },
};
</script>

<style>
.wz-article-nav {
    display: flex;
    width: 100%;
    align-items: center;
}

.wz-article-nav > div {
    flex: 1;
}

.wz-article-nav > div {
    flex: 1;
}

.wz-article-nav > div > span,
.wz-article-nav > div > i {
    cursor: pointer;
}
    
.wz-article-nav > div > span:hover,
.wz-article-nav > div > i:hover {
    color: #c4953b !important;
}

@media screen and (max-width: 1200px) {
    .home_cover {
        display: none !important;
    }
}

.home_cover {
    background: -moz-linear-gradient(
        top,
        rgb(0, 157, 218) 0%,
        rgb(0, 213, 252) 100%
    );
    background: -webkit-linear-gradient(
        top,
        rgb(0, 157, 218) 0%,
        rgb(0, 213, 252) 100%
    );
    background: linear-gradient(
        to bottom,
        rgb(0, 157, 218) 0%,
        rgb(0, 213, 252) 100%
    );
    cursor: pointer;
    position: absolute !important;
    top: 0;
    left: 0;
    width: 90px;
    height: 100%;
    z-index: 50;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;
    background-position: left center;
    background-repeat: no-repeat;
    background-size: cover;
}
.home_cover img {
    position: relative;
    z-index: 1;
    vertical-align: top;
    max-width: 100%;
}

.home_cover img:nth-child(2) {
    margin: 20px 0 30px;
}

.home_cover img:nth-child(4) {
    margin-top: 30px;
}
.home_cover > div {
    width: 90px;
    transform: translateX(calc(-50%));
    background-color: transparent;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 60px;
    left: 50%;
    flex-direction: column;
}
.home_cover > div i {
    transform: rotate(45deg);
    opacity: 1;
    width: 1px;
    height: 11px;
    display: block;
    background-color: #ffffff;
}
.home_cover > div i + i {
    transform: rotate(-45deg);
    margin-top: -4px;
}
.home_cover > div::after {
    content: "HOME";
    font-size: 15px;
    line-height: 20px;
    color: #ffffff;
    font-weight: 300;
    display: block;
    margin-top: 7px;
}
</style>
